export const RESET = 'EXCMAGREEMENTSLA_UPDATE_RESET'
export const SET_ERROR = 'EXCMAGREEMENTSLA_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXCMAGREEMENTSLA_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXCMAGREEMENTSLA_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXCMAGREEMENTSLA_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXCMAGREEMENTSLA_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXCMAGREEMENTSLA_UPDATE_UPDATE_RETRIEVED'
